module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('ext-table', {
    attrs: {
      "fields": {
        name: {
          label: 'Роль'
        }
      },
      "deleteProxy": {
        url: 'api/role/' + _vm.selectedRoleId,
        method: 'delete'
      },
      "loadProxy": {
        url: 'api/role',
        method: 'get'
      },
      "per-page": 5
    },
    on: {
      "select": function (id) {
        _vm.selectedRoleId = id
      }
    }
  }, [_c('template', {
    slot: "createForm"
  }, [_c('ext-form', {
    attrs: {
      "formData": _vm.roleFormData,
      "submitProxy": _vm.createRoleProxy,
      "submitBtnText": "Создать"
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('name')
    },
    attrs: {
      "label": "Роль",
      "feedback": _vm.errors.first('name')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|eng'),
      expression: "'required|eng'"
    }, {
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.roleFormData.name),
      expression: "roleFormData.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.roleFormData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roleFormData.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "updateForm"
  }, [_c('ext-form', {
    attrs: {
      "formData": _vm.roleFormData,
      "submitProxy": {
        url: 'api/role/' + _vm.selectedRoleId,
        method: 'post'
      },
      "loadProxy": {
        url: 'api/role/' + _vm.selectedRoleId,
        method: 'get'
      },
      "submitBtnText": "Обновить"
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('name')
    },
    attrs: {
      "label": "Роль",
      "feedback": _vm.errors.first('name')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|eng'),
      expression: "'required|eng'"
    }, {
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.roleFormData.name),
      expression: "roleFormData.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.roleFormData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roleFormData.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1)], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('ext-table', {
    attrs: {
      "filter": {
        role_id: _vm.selectedRoleId
      },
      "fields": {
        entity: {
          label: 'Сущность'
        },
        create: {
          label: 'Создание',
          formatter: _vm.formatBool
        },
        read: {
          label: 'Чтение',
          formatter: _vm.formatBool
        },
        update: {
          label: 'Обновление',
          formatter: _vm.formatBool
        },
        delete: {
          label: 'Удаление',
          formatter: _vm.formatBool
        },
        owner: {
          label: 'Изменение владельцем',
          formatter: _vm.formatBool
        }
      },
      "loadProxy": {
        url: 'api/right',
        method: 'get'
      },
      "deleteProxy": {
        url: 'api/right/' + _vm.selectedRightId,
        method: 'delete'
      },
      "per-page": 5,
      "disableCreateBtn": !_vm.selectedRoleId
    },
    on: {
      "select": function (id) { return _vm.selectedRightId = id; }
    }
  }, [_c('template', {
    slot: "createForm"
  }, [_c('right-form', {
    attrs: {
      "submitProxy": {
        url: 'api/right',
        method: 'put'
      },
      "extraData": {
        role_id: _vm.selectedRoleId
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "updateForm"
  }, [_c('right-form', {
    attrs: {
      "submitProxy": {
        url: 'api/right/' + _vm.selectedRightId,
        method: 'post'
      },
      "loadProxy": {
        url: 'api/right/' + _vm.selectedRightId,
        method: 'get'
      },
      "extraData": {
        role_id: _vm.selectedRoleId
      }
    }
  })], 1), _vm._v(" "), _c('right-form')], 2)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ext-table', {
    attrs: {
      "fields": {
        name: {
          label: 'Имя'
        },
        login: {
          label: 'Логин'
        },
        role: {
          label: 'Роль',
          formatter: function(role) {
            return role.name
          }
        }
      },
      "deleteProxy": {
        url: 'api/user/' + _vm.selectedUserId,
        method: 'delete'
      },
      "loadProxy": {
        url: 'api/user',
        method: 'get'
      },
      "per-page": 5
    },
    on: {
      "select": function (id) {
        _vm.selectedUserId = id
      }
    }
  }, [_c('template', {
    slot: "createForm"
  }, [_c('full-account-form', {
    attrs: {
      "submitProxy": {
        url: 'api/user',
        method: 'put'
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "updateForm"
  }, [_c('full-account-form', {
    attrs: {
      "submitProxy": {
        url: 'api/user/' + _vm.selectedUserId,
        method: 'post'
      },
      "loadProxy": {
        url: 'api/user/' + _vm.selectedUserId,
        method: 'get'
      }
    }
  })], 1)], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ccfdfd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/RightsManage.vue
// module id = 229
// module chunks = 1